import React from 'react';

interface RightArrowIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const RightArrowIcon: React.FC<RightArrowIconProps> = ({ 
  width = 20, 
  height = 21, 
  color = '#161616',
  className,
  style 
}) => {
  // width와 height를 CSS 스타일로 처리
  const svgStyle: React.CSSProperties = {
    width: typeof width === 'string' ? width : `${width}px`,
    height: typeof height === 'string' ? height : `${height}px`,
    ...style
  };

  // viewBox를 기준으로 한 기본 크기 (픽셀)
  const defaultWidth = typeof width === 'number' ? width : 20;
  const defaultHeight = typeof height === 'number' ? height : 21;

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={defaultWidth} 
      height={defaultHeight} 
      fill="none" 
      viewBox="0 0 20 21"
      className={className}
      style={svgStyle}
    >
      <path 
        d="M7.97848 6.81344C8.17374 6.61818 8.4896 6.61818 8.68486 6.81344L12.0182 10.1468C12.2135 10.342 12.2135 10.6579 12.0182 10.8532L8.68486 14.1865C8.4896 14.3817 8.17374 14.3817 7.97848 14.1865C7.78322 13.9912 7.78322 13.6754 7.97848 13.4801L10.9586 10.5L7.97848 7.51982C7.78322 7.32456 7.78322 7.0087 7.97848 6.81344Z" 
        fill={color}
      />
    </svg>
  );
};

export default RightArrowIcon;
